import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import noUser from '../../assets/img/no_user.jpg';
import { logout } from '../../helper/comman';
import { ReactComponent as LogoutIcon } from '../../assets/svg/logout.svg';
import {
  setActiveTab,
  setModalAction,
  setShowModal,
} from '../../redux/active-tabs/active-tab.action';
import { getUserImage } from '../../services/user';

const Header = ({
  user,
  userAvatar,
  tenant,
  activeTab,
  setShowModal,
  setModalAction,
  setActiveTab,
}) => {
  const history = useHistory();
  const [profImage, setProfImage] = useState(noUser);
  useEffect(() => {
    if (user._id) {
      (async () => {
        const resImg = await getUserImage(user._id);
        if (resImg.status === 200) {
          let base64ImageString = Buffer.from(resImg.data, 'binary').toString(
            'base64'
          );
          // setProfImage(noUser);
          setProfImage('data:image/jpeg;base64,' + base64ImageString);
        } else {
          setProfImage(noUser);
        }
      })();
    }
  }, [user._id, userAvatar]);

  return (
    <header className='site-header' id='siteHeader'>
      <nav className='navbar navbar-expand-lg navbar-light'>
        <div className='container-fluid'>
          <a className='navbar-brand' href='#!'>
            <div className='brand-wrapper'>
              {/* <img src='assets/images/logo-icon.png' alt='' /> */}
              <h4>
                {user.tenantName}
                {/* <label for="">Private bank Customers list</label> */}
              </h4>
            </div>
          </a>
          {/* <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarNavDropdown'
            aria-controls='navbarNavDropdown'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button> */}
          <div className='header-action-btn'>
            <ul>
              <li>
                <span
                  className='log-out-btn'
                  onClick={async () => {
                    await logout();
                    history.push('/');
                  }}>
                  <LogoutIcon />
                </span>
              </li>
              <li
                className='user-image'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setActiveTab('profile');
                  history.push('/profile');
                }}>
                <img src={profImage} alt='' />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

const mapStateToProps = ({
  authReducer: { user, tenant },
  activeTabReducer: { activeTab },
}) => ({
  user: user,
  userAvatar: user?.avatar,
  tenant: tenant,
  activeTab: activeTab,
});

const mapDispatchToProps = (dispatch) => ({
  setShowModal: (data) => dispatch(setShowModal(data)),
  setModalAction: (data) => dispatch(setModalAction(data)),
  setActiveTab: (data) => dispatch(setActiveTab(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
